import { OnInit, Component, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ConsultationInfoService } from 'src/app/services/StoreService/ConsultationInfoService/consultation-info-service.service';
import { Router } from '@angular/router';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/** @title Datepicker emulating a Year and month picker */
@Component({
  selector: 'app-datepicker-month-and-year',
  templateUrl: 'month-and-year-picker.component.html',
  styleUrls: ['month-and-year-picker.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class MonthAndYearPickerComponent implements OnInit {

  constructor(
    private consultationInfoService: ConsultationInfoService,
    private router: Router
  ) { }

  @Output() enable: EventEmitter<boolean> = new EventEmitter();

  min: any = "2023";
  today = new Date();
  max = new Date(this.today.getFullYear(), this.today.getMonth() - 1, this.today.getDate());

  //date = new FormControl(moment(this.max));
  date = new FormControl();

  ngOnInit(): void {
    const url = this.router.url;

    if (url.includes('tracing')) {
      this.max = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
    } else {
      this.max = new Date(this.today.getFullYear(), this.today.getMonth() - 1, this.today.getDate());
    }
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    //const ctrlValue = this.date.value!;
    const ctrlValue = moment(this.max);
    let month = null;
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    if (normalizedMonthAndYear.month() < 9) {
      month = "0" + (normalizedMonthAndYear.month() + 1);
      this.consultationInfoService.newYearAndMonth(normalizedMonthAndYear.year(), month);
    } else {
      this.consultationInfoService.newYearAndMonth(normalizedMonthAndYear.year(), normalizedMonthAndYear.month() + 1);
    }
    this.consultationInfoService.newWeekSelected(null, null);
    this.consultationInfoService.newLastWeek(null, null);
    this.date.setValue(ctrlValue);
    this.enable.emit(true);
    datepicker.close();
  }
}
